export default "Votre SIRET suffit. En 60 secondes, estimez vos primes CEE applicables à votre activité professionnelle. Résultat chiffré, sans inscription.";

